







































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import PaginationModule from "@/store/pagination";
import ModalPaginationModule from "@/store/modalPagination";
import OrderModule from "@/store/order";

@Component
export default class Pagination extends Vue {
  private get query() {
    return this?.$route?.query;
  }

  private get currentPageNum() {
    return this?.$route?.params?.pageNum ? this.$route.params.pageNum : 1;
  }

  private get total() {
    return PaginationModule.total;
  }

  private get modalTotal() {
    return ModalPaginationModule.total;
  }

  private get modalPageNum() {
    return ModalPaginationModule.pageNum;
  }

  private get pageName() {
    return this?.$route.name;
  }

  private get modalPageNums() {
    const { limit } = ModalPaginationModule;
    const pageNum = Math.ceil(this.modalTotal / limit);
    // eslint-disable-next-line
    return isNaN(pageNum) ? 1 : pageNum;
  }

  private get pageNums() {
    const { limit } = PaginationModule;
    const pageNum = Math.ceil(this.total / limit);
    // eslint-disable-next-line
    return isNaN(pageNum) ? 1 : pageNum;
  }

  private get isNewOrdersModal() {
    return OrderModule.isNewOrdersModal;
  }

  private isCurrent(pageNum: number) {
    // eslint-disable-next-line prettier/prettier
    return this?.$route?.params?.pageNum === String(pageNum);
  }

  private modalPrev() {
    if (this.modalPageNum > 1) {
      ModalPaginationModule.commitPageNum(this.modalPageNum - 1);
    }
  }

  private modalNext() {
    if (this.modalPageNum < this.modalPageNums) {
      ModalPaginationModule.commitPageNum(this.modalPageNum + 1);
    }
  }

  private changeModalPageNum(num: number) {
    ModalPaginationModule.commitPageNum(num);
  }
}
